<section
  class="ui-form-section"
  [attr.aria-label]="showHeader() ? null : title()"
>
  @if (showHeader()) {
    <header class="ui-form-section__header">
      <div class="ui-form-section__header-start">
        <ng-content select="[header-start]" />
        <div class="ui-form-section__heading">
          <h3
            class="ui-form-section__title"
            [class.ui-form-section__title--clickable]="titleClickable()"
            [attr.role]="titleClickable() ? 'button' : null"
            [attr.tabindex]="titleClickable() ? 0 : null"
            (click)="onTitleClick()"
            (keydown)="onTitleKeydown($event)"
          >
            {{ title() }}
          </h3>
          @if (description()) {
            <p class="ui-form-section__description">{{ description() }}</p>
          }
        </div>
      </div>
      <div class="ui-form-section__actions">
        @if (showAddButton()) {
          <ui-button
            variant="primary"
            size="sm"
            (pressed)="addClick.emit()"
          >
            {{ addLabel() }}
          </ui-button>
        }
        <ng-content select="[actions]" />
      </div>
    </header>
  }
  <div class="ui-form-section__body">
    <ng-content />
  </div>
</section>
